import { useLang } from "../../i18n/LanguageContext";

export const EditorialMarquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div data-testid="editorial-marquee" className="bg-slate-900 py-5 overflow-hidden border-y border-slate-800">
      <div className="marquee-track flex items-center gap-10 whitespace-nowrap">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10 text-[13px] font-mono uppercase tracking-[0.3em] text-slate-400">
            {item}
            <span className="text-emerald-500 text-[9px]">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};
